document.addEventListener("DOMContentLoaded", function() {
  var faqWrapper = document.querySelector('.wp-block-group:has(.wp-block-details.is-style-faq)'); // Replace 'faq-wrapper' with the ID of your wrapper element
  var faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": []
  };

  if (faqWrapper) {
    var faqSections = faqWrapper.querySelectorAll('.wp-block-details.is-style-faq');

    faqSections.forEach(function(faqSection) {
      // Function to capture content when details are open
      function captureContent() {
        var question = faqSection.querySelector('summary').innerText.trim();
        console.log('Question:', question);

        var answerElements = faqSection.querySelectorAll('*');
        var answer = '';

        answerElements.forEach(function(answerElement) {
          answer += answerElement.innerText.trim() + ' ';
        });

        answer = answer.trim();
        console.log('Answer:', answer);

        faqData.mainEntity.push({
          "@type": "Question",
          "name": question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": answer
          }
        });
      }

      // Check if details are already open
      if (!faqSection.open) {
        // If not, apply 'open' attribute and capture content
        faqSection.open = true;
        captureContent();
        // Remove 'open' attribute after capturing content
        faqSection.open = false;
      } else {
        // If already open, capture content immediately
        captureContent();
      }
    });

    var scriptTag = document.createElement('script');
    scriptTag.type = 'application/ld+json';
    scriptTag.text = JSON.stringify(faqData);

    document.head.appendChild(scriptTag);
  } else {
    console.error('FAQ wrapper not found.');
  }
});
